import React, { useState } from "react";
import { notify } from "../../../generic";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";
import CtaButton from "../../Interface/CtaButton";

function RenameProduitModal({
  open,
  setOpen,
  produitName,
  produitId,
  categorieId,
  loading,
  onSubmitAction
}) {
  const [produitNewName, setProduitNewName] = useState("");
  const [nameError, setNameError] = useState(false);

  const handleModalClosure = () => {
    setProduitNewName("");
    setNameError(false);
    setOpen(false);
  };

  const handleModalSubmission = async () => {
    const { type, message, details } = await onSubmitAction({
      produitNewName,
      categorieId,
      produitId
    });

    if (type === "success") {
      notify("success", message);
      handleModalClosure();
    } else {
      notify("error", message);
    }
  };

  const handleProduitSubmit = e => {
    if (e.key === "Enter") {
      if (setProduitNewName.length > 0) handleModalSubmission();
      else setNameError(true);
    }
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>
            Renommer le produit <strong>{produitName}</strong>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>Nom du produit</label>
          <input
            name="produit"
            type="text"
            className={`form-control ${nameError ? "has-error" : ""}`}
            onChange={({ target }) => setProduitNewName(target.value)}
            onKeyUp={handleProduitSubmit}
            value={produitNewName}
          />
          <span className={`invalid-feedback ${nameError ? "show" : ""}`}>
            Le produit doit avoir un nom valide
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <CtaButton
            action={handleProduitSubmit}
            text="Renommer"
            busy={loading}
          />
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default RenameProduitModal;
